import { useRef } from 'react';
import { createPortal } from 'react-dom';
import { useClickAway } from '../../utils/hooks/useClickAway.js';
import { getPopoverStyles, getPopoverContentStyles } from './PopoverStyles.js';
import { useDefaultPortalRef } from '../../providers/DefaultPortalRefProvider/DefaultPortalRefProvider.js';
import { useGigerConfig } from '../../providers/useGigerConfig.js';
import { jsx, Fragment, jsxs } from '@emotion/react/jsx-runtime';
import { usePopout } from '../../hooks/usePopout/usePopout.js';

const Popover = _ref => {
  var _useDefaultPortalRef;
  let {
    children,
    isOpen,
    isScrollable = false,
    offset,
    onClickAway,
    placement = 'bottom',
    reference,
    container: containerProp,
    ...rest
  } = _ref;
  const defaultPortal = (_useDefaultPortalRef = useDefaultPortalRef()) === null || _useDefaultPortalRef === void 0 ? void 0 : _useDefaultPortalRef.current;
  const container = containerProp || defaultPortal || window.document.body;
  const {
    setPopoutElement,
    setArrowElement,
    popoutWithArrowStyles,
    state
  } = usePopout(reference, placement, {
    enabled: isOpen,
    offset
  });
  const clickAwayRef = useRef(null);
  useClickAway(clickAwayRef, e => {
    /**
     * Avoid calling onClickAway when the user clicks the same component that opens the Popover
     */
    if (!(reference !== null && reference !== void 0 && reference.contains(e.composedPath()[0]))) {
      onClickAway === null || onClickAway === void 0 ? void 0 : onClickAway(e);
    }
  });
  const setRef = element => {
    setPopoutElement(element);
    clickAwayRef.current = element;
  };
  const gigerConfig = useGigerConfig();
  return jsx(Fragment, {
    children: isOpen && /*#__PURE__*/createPortal(jsxs("div", {
      role: "dialog",
      ref: setRef,
      css: getPopoverStyles(popoutWithArrowStyles, (state === null || state === void 0 ? void 0 : state.placement) || placement, offset),
      ...rest,
      children: [jsx("div", {
        ref: setArrowElement,
        "aria-hidden": "true"
      }), jsx("div", {
        css: getPopoverContentStyles(isScrollable),
        children: children
      })]
    }), gigerConfig.emotionCacheShadowRootContainer || container)
  });
};

export { Popover };
//# sourceMappingURL=Popover.js.map
